import { Routes, Route } from "react-router-dom";
import Home from "./Components/Home";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer";
import Terms from "./Components/Terms";
import PrivacyPolicy from "./Components/PrivacyPolicy";
import Article from "./Components/Article";
import ArticleList from "./Components/ArticleList";
import ArticleDetail from "./Components/ArticleDetail";
import Investment from "./Components/Investment";
import InvestDetail from "./Components/InvestDetail";
import RegisterInvest from "./Components/RegisterInvest";
import Sales from "./Components/Sales";
import Pay from "./Components/Pay";
import Buy from "./Components/Buy";
import Zaad from "./Components/Zaad";
import Edahab from "./Components/Edahab";
import About from "./Components/About";
import Mastercard from "./Components/Mastercard";
import ContactUs from "./Components/Contact";

function Public() {
  return (
    <div>
      <Navbar />
      <div className="w-full px-28 md:px-3">
        <Routes className="w-full px-28 md:px-3">
          <Route path="/" element={<Home />} />
          <Route path="/Article" element={<Article />} />
          <Route path="/About" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />

          <Route path="/Article/List" element={<ArticleList />} />
          <Route path="/Article/List/Detail" element={<ArticleDetail />} />
          <Route path="/Investment" element={<Investment />} />
          <Route path="/investDetail" element={<InvestDetail />} />
          <Route path="/register" element={<RegisterInvest />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/pay" element={<Pay />} />
          <Route path="/Zaad" element={<Zaad />} />

          <Route path="/Edahab" element={<Edahab />} />

          <Route path="/Mastercard" element={<Mastercard />} />

          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/Terms" element={<Terms />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default Public;
